'use client';

import { cn } from '@/lib/utils';
import { Portal, Root as Tooltip, Content as TooltipPrimitiveContent, Provider as TooltipProvider, Trigger as TooltipTrigger } from '@radix-ui/react-tooltip';
import React from 'react';
const TooltipContent = React.forwardRef<React.ElementRef<typeof TooltipPrimitiveContent>, React.ComponentPropsWithoutRef<typeof TooltipPrimitiveContent>>(({
  className,
  sideOffset = 4,
  ...props
}, ref) => <Portal>
    <TooltipPrimitiveContent ref={ref} sideOffset={sideOffset} className={cn('z-[9999] overflow-hidden rounded-md bg-gray-800/90 px-3 py-2 text-sm text-white backdrop-blur-lg backdrop-filter animate-in fade-in-0 zoom-in-95 [box-shadow:0px_2px_4px_0px_#1E293B40] data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2', className)} {...props} />
  </Portal>);
TooltipContent.displayName = TooltipPrimitiveContent.displayName;
export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };